import { useState } from 'react'
import { t, Lang } from './i18n'
import dialogStyles from '../styles/Dialog.module.css'

function hoyISO(): string {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

// Club, 2026-10-23: "añadir entrenamiento no hace nada". Se pedía la fecha con `window.prompt`, que
// algunos navegadores integrados (p. ej. los de apps de escritorio) no soportan: el botón no hacía nada
// y no avisaba. Ahora es un diálogo propio con selector de fecha (sin problemas de formato DD/MM, ver
// el 2026-10-13 en i18n) y el error del API (fecha fuera de temporada…) se muestra dentro.
export function AddEntrenamientoModal({
  lang,
  onAdd,
  onClose,
}: {
  lang: Lang
  // Devuelve el mensaje de error a mostrar, o null si se ha añadido.
  onAdd: (fecha: string) => Promise<string | null>
  onClose: () => void
}) {
  const [fecha, setFecha] = useState(hoyISO)
  const [error, setError] = useState<string | null>(null)
  const [guardando, setGuardando] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!fecha) return
    setGuardando(true)
    const mensaje = await onAdd(fecha)
    setGuardando(false)
    if (mensaje) setError(mensaje)
    else onClose()
  }

  return (
    <dialog open className={dialogStyles.dialog}>
      <h3>{t('nuevoEntrenamiento', lang)}</h3>
      <form onSubmit={handleSubmit}>
        <label>
          {t('fechaEntrenamiento', lang)}
          <input
            type="date"
            autoFocus
            required
            value={fecha}
            onChange={(e) => {
              setFecha(e.target.value)
              setError(null)
            }}
          />
        </label>
        {error && (
          <p role="alert" className="pill pill-danger">
            {error}
          </p>
        )}
        <div className="modal-actions">
          <button type="submit" disabled={guardando}>
            {t('anadir', lang)}
          </button>
          <button type="button" onClick={onClose}>
            {t('cancelar', lang)}
          </button>
        </div>
      </form>
    </dialog>
  )
}
